import { styled } from "goober";

export const Keycap = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 2px;
  background: var(--keycap-bg, var(--alpha4));
  color: var(--keycap-fg, var(--text-secondary));
  white-space: nowrap;
`;
